import * as React from "react";
import { useSearchParams } from "react-router-dom";
import {
  TagDropdownItem,
  TagDropdownNav,
  TagDropdownToggle,
  TagDropdownWrapper,
  IconChevron,
} from "atoms";

const sortOptions = [
  // TODO: Searching by name is returning an Elastic error
  {
    option: "name",
    label: (
      <>
        Name <span>A to Z</span>
      </>
    ),
  },
  {
    option: "createdAt desc",
    label: (
      <>
        Date Added <span>Newest to Oldest</span>
      </>
    ),
  },
  {
    option: "reviewCount desc",
    label: (
      <>
        Reviews <span>Most to Least</span>
      </>
    ),
  },
  {
    option: "reviewCount",
    label: (
      <>
        Reviews <span>Least to Most</span>
      </>
    ),
  },
] as const;

type SearchSortProps = {
  isOpen: boolean;
  // closeSort: VoidFunction;
  toggleIsOpen: VoidFunction;
};

function SearchSort({ isOpen, toggleIsOpen }: SearchSortProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeOption = searchParams.get("sort");
  const activeLabel = sortOptions.find((o) => activeOption === o.option)?.label;

  // If user selects menu option, the menu should close after event bubbles up
  const close: React.ReactEventHandler = (event) => {
    if (event.currentTarget !== event.target) {
      toggleIsOpen();
    }
  };

  const createHandler = (option: string) => () => {
    // TODO: Searching by name is returning an Elastic error
    if (option === "name") {
      searchParams.delete("sort");
    } else {
      searchParams.set("sort", option);
    }
    setSearchParams(searchParams);
  };

  return (
    <TagDropdownWrapper>
      <TagDropdownToggle
        onClick={toggleIsOpen}
        isOpen={isOpen}
        aria-expanded={isOpen}
        variant="secondary"
        size="sm"
      >
        {activeLabel || <>Sort</>}
        <IconChevron size=".75em" />
      </TagDropdownToggle>

      {isOpen && (
        <TagDropdownNav onClick={close} duration={300}>
          <ul>
            {sortOptions.map(({ option, label }) => (
              <li key={option}>
                <TagDropdownItem
                  variant="blank"
                  onClick={createHandler(option)}
                  isActive={
                    option === "name" ? !activeOption : option === activeOption
                  }
                >
                  {label}
                </TagDropdownItem>
              </li>
            ))}
          </ul>
        </TagDropdownNav>
      )}
    </TagDropdownWrapper>
  );
}

export { SearchSort };
